import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/session-summaries/index.js